import ReactGA from "react-ga4"

const analyticsTags = {
    es: {
        ios: "G-NR0JEGPGV0",
        android: "G-1FS98WNWK3"
    },
    pt: {
        ios: "G-L7SBXDPSTK",
        android: "G-ME6SEDTEKH"
    }
}
// The web properties have been removed as GTM will handle web analytics

export function initAnalytics (locale, platform) {
    console.log("initAnalytics", locale, platform)
    const trackingId = analyticsTags[locale]?.[platform];
    
    // Only initialize if tracking ID exists (for ios/android)
    // Web platform is handled by GTM
    if (trackingId) {
        ReactGA.initialize(trackingId);
    }
}
